import { render, staticRenderFns } from "./CdbCustomerSummary.vue?vue&type=template&id=9c837dd6&scoped=true&"
import script from "./CdbCustomerSummary.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerSummary.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerSummary.vue?vue&type=style&index=0&id=9c837dd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c837dd6",
  null
  
)

export default component.exports